import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { api, ApiError } from '@/api/client'
import { PageHeader } from '@/app/shell'
import { BaraSalvare, Camp, Sectiune } from '@/ui/form'

export function GrupNou() {
  const nav = useNavigate()
  const qc = useQueryClient()
  const [g, setG] = useState({
    name: '', destination: '', hotel: '', supplier: '',
    begin_date: '', end_date: '', capacity: '', price_info: '',
    notes: '', internal_notes: '',
  })
  const [eroare, setEroare] = useState<string | null>(null)
  const s = (k: keyof typeof g) => (v: string) => setG((x) => ({ ...x, [k]: v }))

  const salveaza = useMutation({
    mutationFn: () => {
      if (g.name.trim().length < 3) throw new ApiError(400, 'Grupul are nevoie de un nume')
      return api.post<{ group: { id: number } }>('/groups/', {
        ...Object.fromEntries(Object.entries(g).filter(([, v]) => v !== '')),
        capacity: g.capacity ? Number(g.capacity) : undefined,
      })
    },
    onSuccess: (r) => {
      qc.invalidateQueries({ queryKey: ['grupuri'] })
      nav(r?.group?.id ? `/rezervari/grupuri/${r.group.id}` : '/rezervari/grupuri')
    },
    onError: (e) => setEroare(e instanceof Error ? e.message : 'Nu s-a putut salva'),
  })

  return (
    <>
      <PageHeader title="Grup nou" count="linkul de inscriere se genereaza singur" />
      <div className="px-8 pb-0">
        <Sectiune titlu="Calatoria" descriere="Ce apare si pe pagina publica.">
          <Camp eticheta="Nume grup" valoare={g.name} seteaza={s('name')} obligatoriu latime="plin"
            indiciu="ex.: Antalya 7 septembrie, grup Popescu" />
          <Camp eticheta="Destinatie" valoare={g.destination} seteaza={s('destination')} />
          <Camp eticheta="Hotel" valoare={g.hotel} seteaza={s('hotel')} />
          <Camp eticheta="Plecare" tip="date" valoare={g.begin_date} seteaza={s('begin_date')} />
          <Camp eticheta="Intoarcere" tip="date" valoare={g.end_date} seteaza={s('end_date')} />
        </Sectiune>

        <Sectiune titlu="Locuri si pret" descriere="Cate locuri sunt si ce scrie pe link.">
          <Camp eticheta="Locuri" tip="number" valoare={g.capacity} seteaza={s('capacity')}
            indiciu="gol = fara limita" />
          <Camp eticheta="Pret afisat" valoare={g.price_info} seteaza={s('price_info')}
            indiciu="ex.: de la 450 EUR/persoana" />
          <Camp eticheta="Furnizor" valoare={g.supplier} seteaza={s('supplier')} />
          <Camp eticheta="Text pentru participanti" tip="textarea" valoare={g.notes} seteaza={s('notes')}
            latime="plin" indiciu="apare pe pagina publica" />
          <Camp eticheta="Note interne" tip="textarea" valoare={g.internal_notes}
            seteaza={s('internal_notes')} latime="plin" indiciu="nu se vad in afara" />
        </Sectiune>

        <BaraSalvare salveaza={() => { setEroare(null); salveaza.mutate() }}
          seSalveaza={salveaza.isPending} eroare={eroare} eticheta="Creeaza grupul" />
      </div>
    </>
  )
}
